<template>
  <div class="lottery-swiper">
    <swiper
      ref="cardSwiper"
      :options="swiperOptions"
      class="lottery-swiper__container"
      :auto-update="false"
    >
      <swiper-slide
        v-for="(src, index) in lotterieList"
        :key="index"
        class="lottery-swiper__item">
        <div
          class="lottery-swiper__img"
          :style="{backgroundImage: 'url('+src+')'}"></div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

const lotterieList = [
  'https://p0.meituan.net/wxapp/dc41c536470f97cc691053e24e82bc5c36558.png',
  'https://p0.meituan.net/wxapp/185f4a1462e7830524b32e6dc68ea65539304.png',
  'https://p1.meituan.net/wxapp/56d4c8cd15f1b5cc34ba1568dae8601938600.png',
  'https://p0.meituan.net/travelcube/b6afd8b95c29d5e361952e5b71f4bf67253113.png',
  'https://p0.meituan.net/wxapp/b5e1e58c261a9167e6a2c0403c32292344162.png',
  'https://p0.meituan.net/wxapp/ac6aabbc8ff90932dcfb58ccfc3df41646721.png',
  'https://p1.meituan.net/wxapp/56d3c2dac466f8879ee8b56b8dad08ce49226.png',
  'https://p0.meituan.net/wxapp/267710648e7eaaa142f87c33c5fe031148689.png'
];
const lotteryLen = lotterieList.length;

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        initialSlide: 0,
        loop: true,
        loopedSlides: lotteryLen,
        autoplay: {
          disableOnInteraction: false,
          delay: 1000
        },
        speed: 800
      },
      lotterieList,
    };
  },
  computed: {
    swiper() {
      return this.$refs.cardSwiper.$swiper;
    },
  }
};
</script>

<style scoped lang="less">
.lottery-swiper {
  margin-left: 0.2rem;
  .lottery-swiper__item {
    width: 2.2rem;
    height: 3.87rem;
  }
  .lottery-swiper__img {
    background-size: auto 100%;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    background-position: right;
  }
}
</style>
